import React from 'react'

import DoctorsLayout from 'presentation/hospital/layouts/Doctors'

export default function Doctors() {
  return <DoctorsLayout />
}
